import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Eager load ALL pages for SEO and instant display - NO LAZY LOADING
import Home from "./pages/Home";
import Whitepaper from "./pages/Whitepaper";
import HowToEarn from "./pages/HowToEarn";
import Chart from "./pages/Chart";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import RiskWarning from "./pages/RiskWarning";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Sitemap from "./pages/Sitemap";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/whitepaper" element={<Whitepaper />} />
          <Route path="/how-to-earn" element={<HowToEarn />} />
          <Route path="/chart" element={<Chart />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/risk-warning" element={<RiskWarning />} />
          <Route path="/sitemap" element={<Sitemap />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
